/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type models_MetadataPropertyUpdateRequest = {
    default_value?: any;
    label: string;
    options?: Array<string>;
    required?: boolean;
    type: models_MetadataPropertyUpdateRequest.type;
};
export namespace models_MetadataPropertyUpdateRequest {
    export enum type {
        STRING = 'string',
        NUMBER = 'number',
        BOOLEAN = 'boolean',
        SELECT = 'select',
    }
}

